// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"57":"index","601":"chunk-zzui"}[chunkId] + "." + {"57":"661d184d","601":"e31add1f"}[chunkId] + ".css";
};